
import type { Promotion } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import type { PromotionDomainService } from '../../services'
import { computed, defineComponent, ref } from 'vue'
import { CONTAINER } from '../../config'
import { TYPES } from '../../config/inversify.types'
import PromotionCard from './promotion-card.component.vue'
import PromotionProductListPreview from './promotion-product-list-preview.component.vue'

export default defineComponent({
  name: 'PromotionPreview',
  components: {
    PromotionProductListPreview,
    PromotionCard,
  },
  props: {
    promotion: {
      type: Object as PropType<Promotion>,
      required: true,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const cardRef = ref<HTMLElement | null>(null)

    const domainService = CONTAINER.get<PromotionDomainService>(TYPES.PromotionDomainService)

    const isProductListPreviewOpen = computed(() => {
      return domainService.showProductListPreview?.(props.promotion.setting)
    })

    const navigationUrl = computed<string | undefined>(() => {
      if (!props.promotion.setting.config?.url) {
        return
      }

      return domainService.getNavigationUrl?.(props.promotion.setting.config.url).toString()
    })

    const wrapperAttributes = computed<{
      tag: string
      attrs?: Record<string, string>
    }>(() => {
      if (navigationUrl.value) {
        return {
          tag: 'a',
          attrs: {
            href: navigationUrl.value,
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        }
      }

      return { tag: 'section' }
    })

    const buttonText = computed(() => {
      return domainService.getButtonText(props.promotion.setting)
    })

    const buttonAriaText = computed(() => {
      return domainService.getButtonAriaText(props.promotion.setting)
    })

    const subtitle = computed(() => {
      return domainService.getSubtitle(props.promotion.setting)
    })

    return {
      baseClass: 'epb-promotion-preview',
      cardRef,
      isProductListPreviewOpen,
      navigationUrl,
      wrapperAttributes,
      buttonText,
      buttonAriaText,
      subtitle,
    }
  },
})
